import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DataLake } from "@graylog/enterprise-api";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
const toggleStreamDataLakeConfigStatus = ({ streamIds, enabled }) => DataLake.toggleConfigEnableStatus({
  stream_ids: streamIds,
  enabled
});
const useStreamDataLakeStatusMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: onToggleStreamDataLakeConfigStatus } = useMutation({
    mutationFn: toggleStreamDataLakeConfigStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["data-lake-config"]
      });
    },
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("notifications.status_toggle_failed", { ns: "enterprise_data_lake", error: errorThrown }),
        i18n.t("notifications.status_toggle_title", { ns: "enterprise_data_lake" })
      );
    }
  });
  return { onToggleStreamDataLakeConfigStatus };
};
export default useStreamDataLakeStatusMutation;
